import {
    createElementVNode as _$ce,
    className as _$cn,
    createVNode as _$cv,
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
} from 'intact';
import {Icon} from '../icon';
import {Tooltip} from '../tooltip';
import {isInvalid, noop} from 'intact-shared';
import {getRestProps, addStyle, isEmptyString} from '../utils';
import {MediaViewer} from './viewer';
import {makeMediaStyles, makeMediaViewerStyles} from './styles';

var _$tmp0 = {
    'tabindex': '-1'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    const {
        getRootClassNameObj,
        getRootStyle,
        getFileName,
        isLoading,
        shouldShowVisualMediaContent,
        shouldShowImage,
        shouldShowVideo,
        shouldShowAudioLoader,
        shouldShowAudioCard,
        shouldShowErrorCard,
        rootRef,
        imageRef,
        videoRef,
        audioRef,
        getImageProps,
        getVideoProps,
        getVideoKey,
        getAudioLoaderProps,
        getAudioCardAssetSrc,
        getErrorCardAssetSrc,
        getMediaCardIconStyle,
        getPlaceholderAssetStyle,
        shouldShowLoadingIndicator,
        shouldShowLoadingVideoIcon,
        shouldShowPlaceholder,
        getPreviewIconClassName,
        getPlaceholderIconClassName,
        getPlaceholderAssetSrc,
        getPreviewTitle,
        onClick,
        onPreview,
        canPreview,
        shouldShowVideoPlayTrigger,
        shouldShowMaskLayer,
        shouldShowLoadingOverlay,
        getViewerItem,
        getMaskValue,
        isStandalonePreviewRendered,
        isStandalonePreviewVisible,
        closeStandalonePreview,
        afterStandalonePreviewClose,
    } = this.media;
    
    const {
        className, style,
    } = this.get();
    const {k} = this.config;
    const isEmptySlot = (value) => {
        if (isInvalid(value) || isEmptyString(value)) return true;
        if (Array.isArray(value)) return value.every(item => isEmptySlot(item));
        if (value && value.type === 1) return isEmptySlot(value.children);
    
        return false;
    };
    const renderSlot = (name, params) => $blocks[name] ? $blocks[name](noop, params) : undefined;
    const viewerItem = getViewerItem();
    const maskValue = getMaskValue();
    const loadingSlot = isLoading() ? renderSlot('loading', viewerItem) : undefined;
    const errorSlot = this.media.isError() ? renderSlot('error', viewerItem) : undefined;
    const maskSlot = shouldShowMaskLayer() ? renderSlot('mask', maskValue) : undefined;
    const hasLoadingSlot = !isEmptySlot(loadingSlot);
    const hasErrorSlot = !isEmptySlot(errorSlot);
    const hasMaskSlot = !isEmptySlot(maskSlot);
    const showCustomLoadingLayer = isLoading() && hasLoadingSlot;
    const showCustomErrorLayer = this.media.isError() && hasErrorSlot;
    const showCustomMaskLayer = hasMaskSlot && shouldShowMaskLayer();
    const showCustomStateLayer = showCustomLoadingLayer || showCustomErrorLayer;
    const showVideoPlayTrigger = shouldShowVideoPlayTrigger() && !showCustomStateLayer;
    const shouldShowOverlay = canPreview() || showCustomMaskLayer || showVideoPlayTrigger;
    const shouldShowDefaultPreviewTrigger = canPreview() || showVideoPlayTrigger;
    const shouldShowPreviewTriggerInOverlay = canPreview() && !showVideoPlayTrigger;
    const shouldShowStandalonePreviewTrigger = shouldShowDefaultPreviewTrigger && showVideoPlayTrigger;
    const showNameTooltip = this.get('showNameTooltip');
    const nameTooltipProps = {
        theme: 'light',
        ...(this.get('nameTooltipProps') || {}),
    };
    const mediaName = getFileName();
    const placeholderAssetSrc = getPlaceholderAssetSrc();
    const audioCard = (
        _$ce(2, 'div', (
            _$ce(2, 'img', null, 1, _$cn(`${k}-media-card-icon ${k}-media-audio-card-icon`), {
                'src': getAudioCardAssetSrc(),
                'alt': '',
                'draggable': false,
                'style': getMediaCardIconStyle()
            })
        ), 2, _$cn(`${k}-media-audio-card`))
    );
    const errorCard = (
        _$ce(2, 'div', (
            _$ce(2, 'img', null, 1, _$cn(`${k}-media-card-icon ${k}-media-error-card-icon`), {
                'src': getErrorCardAssetSrc(),
                'alt': '',
                'draggable': false,
                'style': getMediaCardIconStyle()
            })
        ), 2, _$cn(`${k}-media-error-card`))
    );
    const classNameObj = {
        ...getRootClassNameObj(),
        [`${k}-media-custom-loading`]: showCustomLoadingLayer,
        [`${k}-media-custom-error`]: showCustomErrorLayer,
        [`${k}-media-custom-mask`]: showCustomMaskLayer,
        [className]: className,
        [makeMediaStyles(k)]: true,
    };
    
    return _$cv('div', {
        'className': _$cn(classNameObj),
        'style': addStyle(style, getRootStyle()),
        'title': showNameTooltip ? undefined : getFileName(),
        'ref': rootRef,
        ...getRestProps(this),
        'ev-click': onClick
    }, [
        _$ce(2, 'div', [
            (shouldShowLoadingOverlay() && !showCustomLoadingLayer) ?
                _$ce(2, 'div', null, 1, _$cn(`${k}-media-loading-overlay`)) :
                undefined,
            (shouldShowImage()) ?
                _$cv('img', {
                    'className': _$cn({
                        [`${k}-media-image`]: true,
                        [`${k}-media-visual-hidden`]: !shouldShowVisualMediaContent(),
                    }),
                    'ref': imageRef,
                    ...getImageProps()
                }) :
                shouldShowVideo() ?
                    _$cv('video', {
                        'key': getVideoKey(),
                        'className': _$cn({
                            [`${k}-media-video`]: true,
                            [`${k}-media-visual-hidden`]: !shouldShowVisualMediaContent(),
                        }),
                        'ref': videoRef,
                        ...getVideoProps()
                    }) :
                    undefined,
            (shouldShowAudioLoader()) ?
                _$cv('audio', {
                    'className': _$cn(`${k}-media-audio-loader`),
                    'ref': audioRef,
                    ...getAudioLoaderProps()
                }) :
                undefined,
            (shouldShowErrorCard() && !showCustomErrorLayer) ?
                errorCard :
                shouldShowAudioCard() && !showCustomStateLayer ?
                    audioCard :
                    shouldShowPlaceholder() && !showCustomLoadingLayer && !showCustomErrorLayer ?
                        _$ce(2, 'div', (
                            (placeholderAssetSrc) ?
                                _$ce(2, 'img', null, 1, _$cn(`${k}-media-placeholder-asset`), {
                                    'src': placeholderAssetSrc,
                                    'alt': '',
                                    'draggable': false,
                                    'style': getPlaceholderAssetStyle()
                                }) :
                                _$cc(Icon, {
                                    'className': _$cn(getPlaceholderIconClassName())
                                })
                        ), 2, _$cn(`${k}-media-placeholder`)) :
                        undefined,
            (shouldShowLoadingIndicator() && !showCustomLoadingLayer) ?
                _$ce(2, 'div', (
                    _$ce(2, 'span', null, 1, _$cn(`${k}-media-loading-spinner`))
                ), 2, _$cn(`${k}-media-loading-indicator`)) :
                undefined,
            (shouldShowLoadingVideoIcon() && !showCustomLoadingLayer) ?
                _$cc(Icon, {
                    'className': _$cn(`${k}-media-loading-video-icon ion-ios-play`)
                }) :
                undefined,
            (showNameTooltip) ?
                _$cc(Tooltip, {
                    'className': _$cn(`${k}-media-name-tooltip`),
                    ...nameTooltipProps,
                    'children': (
                        _$ce(2, 'div', null, 1, _$cn(`${k}-media-name-tooltip-trigger`), _$tmp0)
                    ),
                    '$blocks': function($blocks) {
                        var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                        return (
                            (
                                (_$blocks['content'] = function($super) {
                                    return (
                                        _$ce(2, 'div', mediaName, 0, _$cn(`${k}-media-name-tooltip-content`), {
                                            'style': {
                                                maxWidth: '160px',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                            }
                                        })
                                    );
                                }),
                                (__$blocks['content'] = function($super, data) {
                                    var block = $blocks['content'];
                                    var callBlock = function() {
                                        return _$blocks['content'].call($this, $super, data);
                                    };
                                    return block ?
                                        block.call($this, callBlock, data) :
                                        callBlock();
                                })
                            ),
                            __$blocks
                        );
                    }.call($this, _$em)
                }) :
                undefined,
            (showCustomStateLayer && showCustomLoadingLayer) ?
                _$ce(2, 'div', loadingSlot, 0, _$cn(`${k}-media-state-layer ${k}-media-loading-layer`)) :
                undefined,
            (showCustomStateLayer && showCustomErrorLayer) ?
                _$ce(2, 'div', errorSlot, 0, _$cn(`${k}-media-state-layer ${k}-media-error-layer`)) :
                undefined,
            (shouldShowOverlay) ?
                _$ce(2, 'div', [
                    (showCustomMaskLayer) ?
                        maskSlot :
                        undefined,
                    (shouldShowPreviewTriggerInOverlay && !showCustomMaskLayer) ?
                        _$ce(2, 'button', (
                            _$cc(Icon, {
                                'className': _$cn(`${k}-media-preview-icon ${getPreviewIconClassName()}`),
                                'size': 'large'
                            })
                        ), 2, _$cn(`${k}-media-preview-trigger`), {
                            'type': 'button',
                            'title': getPreviewTitle(),
                            'disabled': !canPreview(),
                            'ev-click': onPreview
                        }) :
                        undefined
                ], 0, _$cn(`${k}-media-overlay`)) :
                undefined,
            (shouldShowStandalonePreviewTrigger && !showCustomMaskLayer) ?
                (
                    (showNameTooltip) ?
                        _$cc(Tooltip, {
                            'className': _$cn(`${k}-media-name-tooltip`),
                            ...nameTooltipProps,
                            'children': (
                                _$ce(2, 'button', (
                                    _$cc(Icon, {
                                        'className': _$cn(`${k}-media-preview-icon ${getPreviewIconClassName()}`),
                                        'size': 'large'
                                    })
                                ), 2, _$cn(`${k}-media-preview-trigger ${k}-media-video-preview-trigger`), {
                                    'type': 'button',
                                    'title': getPreviewTitle(),
                                    'disabled': !canPreview(),
                                    'ev-click': onPreview
                                })
                            ),
                            '$blocks': function($blocks) {
                                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                                return (
                                    (
                                        (_$blocks['content'] = function($super) {
                                            return (
                                                _$ce(2, 'div', mediaName, 0, _$cn(`${k}-media-name-tooltip-content`), {
                                                    'style': {
                                                        maxWidth: '160px',
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                    }
                                                })
                                            );
                                        }),
                                        (__$blocks['content'] = function($super, data) {
                                            var block = $blocks['content'];
                                            var callBlock = function() {
                                                return _$blocks['content'].call($this, $super, data);
                                            };
                                            return block ?
                                                block.call($this, callBlock, data) :
                                                callBlock();
                                        })
                                    ),
                                    __$blocks
                                );
                            }.call($this, _$em)
                        }) :
                        _$ce(2, 'button', (
                            _$cc(Icon, {
                                'className': _$cn(`${k}-media-preview-icon ${getPreviewIconClassName()}`),
                                'size': 'large'
                            })
                        ), 2, _$cn(`${k}-media-preview-trigger ${k}-media-video-preview-trigger`), {
                            'type': 'button',
                            'title': getPreviewTitle(),
                            'disabled': !canPreview(),
                            'ev-click': onPreview
                        })
                ) :
                undefined
        ], 0, _$cn(`${k}-media-shell`)),
        (isStandalonePreviewRendered()) ?
            _$cc(MediaViewer, {
                'value': isStandalonePreviewVisible(),
                'item': viewerItem,
                'container': this.get('container'),
                'onClose': closeStandalonePreview,
                'onAfterClose': afterStandalonePreviewClose,
                'className': _$cn(makeMediaViewerStyles(k))
            }) :
            undefined
    ]);
};